var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _circle, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyVideos(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 445,
    height: 224,
    viewBox: "0 0 445 224",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 205.501,
    height: 219,
    rx: 4.5,
    fill: "white",
    stroke: "#C4CAD4",
    strokeWidth: 5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 236.39,
    y: 2.5,
    width: 205.501,
    height: 219,
    rx: 4.5,
    fill: "white",
    stroke: "#C4CAD4",
    strokeWidth: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2539 138H181.011",
    stroke: "#6324C6",
    strokeWidth: 8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M248.127 138H414.901",
    stroke: "#6324C6",
    strokeWidth: 8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2363 157H111.86",
    stroke: "#A7B0BE",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M248.127 157H345.751",
    stroke: "#C4CAD4",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M5 105.347H205",
    stroke: "#C4CAD4",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M136.17 111.276C139.293 111.276 141.824 108.654 141.824 105.42C141.824 102.185 139.293 99.563 136.17 99.563C133.048 99.563 130.517 102.185 130.517 105.42C130.517 108.654 133.048 111.276 136.17 111.276Z",
    fill: "#7B899D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5 105.347H134.854",
    stroke: "#7B899D",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M239 105L439 105.017",
    stroke: "#C4CAD4",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M331.161 66.7752L352.442 51.3371C352.881 50.9624 353.027 50.3628 352.661 49.8382C352.588 49.7633 352.515 49.6884 352.442 49.6134L331.161 34.1753C330.723 33.8756 330.065 33.9505 329.699 34.4751C329.553 34.625 329.479 34.8498 329.479 35.0746V65.9508C329.479 66.5504 329.918 67 330.503 67C330.723 66.9251 330.942 66.8501 331.161 66.7752Z",
    fill: "#6324C6"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 21.2432,
    y1: 197.322,
    x2: 33.0094,
    y2: 197.322,
    stroke: "#7D41DC",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 128.127,
    y1: 197.322,
    x2: 139.893,
    y2: 197.322,
    stroke: "#7D41DC",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 45.8662,
    y1: 197.59,
    x2: 91.1119,
    y2: 197.59,
    stroke: "#A7B0BE",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 152.75,
    y1: 197.59,
    x2: 197.996,
    y2: 197.59,
    stroke: "#A7B0BE",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 251.064,
    y1: 197.322,
    x2: 262.831,
    y2: 197.322,
    stroke: "#7D41DC",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 357.948,
    y1: 197.322,
    x2: 369.714,
    y2: 197.322,
    stroke: "#7D41DC",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 275.688,
    y1: 197.59,
    x2: 320.933,
    y2: 197.59,
    stroke: "#A7B0BE",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 382.571,
    y1: 197.59,
    x2: 427.817,
    y2: 197.59,
    stroke: "#A7B0BE",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 101.309,
    y1: 39.4077,
    x2: 101.309,
    y2: 61.6193,
    stroke: "#6324C6",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    x1: 119.61,
    y1: 39.4077,
    x2: 119.61,
    y2: 61.6193,
    stroke: "#6324C6",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5303,
    cy: 21,
    r: 8,
    fill: "#C4CAD4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 255.53,
    cy: 21,
    r: 8,
    fill: "#C4CAD4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyVideos);
export default __webpack_public_path__ + "static/media/empty-videos.807bc20cd95d80e1214ef5d09d4ce283.svg";
export { ForwardRef as ReactComponent };